<app-initial-loading />

<hlm-toaster position="bottom-right" />
<app-notification-modal />
<ngx-loading-bar [color]="'#059669'" [includeSpinner]="false" [height]="'4px'" />
<router-outlet />


